<template lang="pug">
v-dialog(:value="value" @input="updateValue" max-width="468")
  v-card
    v-card-title.headline.justify-space-between
      | {{title}}
    v-card-text
      v-form(ref="form")
        v-text-field(
          v-model="model.name" 
          label='Plan name'
          :rules="[RULES.REQUIRED]"
          :error="formErrors.hasError('name')"
          :error-messages="formErrors.fields.name"
        )
        v-text-field(
          v-model="model.price"
          label='Plan price'
          :rules="[RULES.REQUIRED]"
          :error="formErrors.hasError('price')"
          :error-messages="formErrors.fields.price"
        )
        v-text-field(
          v-model="model.duration"
          label='Plan duration'
          :rules="[RULES.REQUIRED]"
          :error="formErrors.hasError('duration')"
          :error-messages="formErrors.fields.duration"
          type="number"
        )
        v-row
          v-col(
            cols="12"
          )
            h4 Description Items
            .d-flex.align-center(v-for="(item, index) in model.description_items")
              v-text-field(
                label='Description'
                v-model="item.description"
                single-line
              )
              v-btn(
                @click="model.removeDescriptionItem(index)"
                icon
              )
                v-icon mdi-delete
            .d-flex.align-center.justify-center
              v-btn(color="primary" @click="model.addNewDescriptionItem()" small) Add Item
        .d-flex.mt-10
          template(v-if="!editMode")
            v-btn(color="primary" outlined @click="closeModal").ml-auto.mr-3 Cancel
            v-btn(color="primary" depressed @click="addItem") Add
          template(v-if="editMode")
            v-btn(color="primary" outlined @click="closeModal").ml-auto.mr-3 Cancel
            v-btn(color="primary" depressed @click="updateItem") Save
</template>

<script>
import { REQUIRED } from "@/util/validation-rules";
import FormErrors from "@/util/form-errors"
import ErrorMixin from "@/mixins/errors.mixin"
import {showSnackbar} from "@/util"
import {PaymentsService} from "../core/payments-service";
import {PlanModel} from "../core/models/PlanModel";

export default {
  components: {
    imageUploadCrop: () => import('@/app/exercise/components/ImageUploadCrop.vue'),
  },
  props: {
    editMode: {
      default: false,
      type: Boolean,
    },
    itemModel: {
      default: null,
      type: Object,
    },
    value: {
      type: Boolean,
    },
  },

  mixins: [ErrorMixin],

  computed: {
    title() {
      if (this.editMode) {
        return 'Edit Plan'
      }
      return 'Add new Plan'
    },
    disableExamPublishing() {
      return !this.model.canMakePublicVisible && !this.model.publicVisible;
    },
  },

  data: () => ({
    svc: null,
    formErrors: null,
    model: new PlanModel(),
    deleteConfirmationModal: false,
    RULES: {
      REQUIRED,
    },
  }),

  created() {
    this.init()
  },

  watch: {
    value(isModalOpen) {
      if(isModalOpen) {
        this.setModelFromProp();
      } else {
        this.formReset();
      }
    },
  },

  methods: {
    init() {
      this.svc = new PaymentsService();
      this.formErrors = new FormErrors();
    },
    formReset() {
      this.model = new PlanModel();
      this.formErrors = new FormErrors();
      this.$refs.form.reset();
    },
    setModelFromProp() {
      Object.assign( this.model, this.itemModel );
    },
    updateValue(value) {
      this.$emit('input', value)
    },
    closeModal() {
      this.$emit('closeModal')
    },
    showDeleteConfirmationModal() {
      this.deleteConfirmationModal = true;
    },
    async addItem() {
      try {
        if (!this.$refs.form.validate() || !this.model.validate(this.formErrors) ) {
          showSnackbar('Invalid fields', {color: 'error'});
          return false;
        }
        await this.svc.createPlan(this.model);
        this.$emit('itemCreated');
        this.closeModal();
      } catch (error) {
        this.processErrorWithForm(error, {
          redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE,
          formErrors: this.formErrors, 
          apiAttributes: this.model._apiAttributes
        });
      }
    },
    async updateItem() {
      const isModelChanged = JSON.stringify(this.model) !== JSON.stringify(this.itemModel);
      if (!isModelChanged) {
        this.closeModal();
        return;
      }
      try {
        if (!this.$refs.form.validate() || !this.model.validate(this.formErrors) ) {
          showSnackbar('Invalid fields', {color: 'error'});
          return false;
        }
        await this.svc.putPlan(this.model.id, this.model);
        this.$emit('itemUpdated');
        this.closeModal();
      } catch (error) {
        this.processErrorWithForm(error, {
          redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE,
          formErrors: this.formErrors, 
          apiAttributes: this.model._apiAttributes
        });
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.v-btn::v-deep {
  .v-btn__content {
    max-width: 100%;
  }
}
</style>
